import React, { useEffect, useState } from "react";
import Sidenav from "./sidenav/Sidenav";
import Topnav from "./topnav/Topnav";
import "./Home.scss";
import { Outlet, useLocation } from "react-router-dom";
import postal from "postal";
import Spinner from "../Common/Loading/Spinner";
import Footer from "./Footer/Footer";
import axios from "axios";
import easyBotIcon from "../../assets/images/easy-genie.svg"
import sologenieLogi from "../../assets/images/genieSoloIcon.svg"

import ChatBotPopUp from "../ChatBotPopUp/ChatBotPopUp";
import { generateRandomNumber } from "../../util/utils";

const Home = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [myTheme, setMyTheme] = useState(localStorage.getItem("theme"));
  const [showEasyBot, setShowEasyBot] = useState(false);
  const [animateIcon, setAnimateIcon] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    setIsChatOpen(false);
  }, [location]);
  const getData = (val) => {
    setMyTheme(val);
  };

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        sessionStorage.setItem("ipAddress", response.data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    fetchIpAddress();
  }, []);

  var subscription = postal.subscribe({
    channel: "baas",
    topic: "loader",
    callback: (data) => {
      setLoading(data);
    },
  });
  const handleChatIconClick = () => {
    if (!showEasyBot) {
      // 1st click → show easyBotIcon with animation
      setAnimateIcon(true);
      setShowEasyBot(true);
      setTimeout(() => setAnimateIcon(false), 600);
    } else {
      // 2nd click → open chatbot
      setIsChatOpen(true);
    }
  };

  const closeChatPopup = () => {
    // Close chatbot and revert to solo logo
    setIsChatOpen(false);
    setShowEasyBot(false);
  };
  return (
    <>
      {loading ? <Spinner /> : <></>}
      <div className="home-container">
        <Sidenav myTheme={myTheme} />
        <div className="footer-page-wrapper">
          <div className="page-wrapper">
            <Topnav sendData={getData} />
            <div id="main" className="main-panel">
              <Outlet context={{ myTheme: myTheme }} />
              <div  className={`easy-chat-bot ${showEasyBot ? "big-mode" : ""}`} onClick={handleChatIconClick}>
                <img
                  className={`easyBotIcon ${animateIcon ? "slide-in" : ""} ${showEasyBot ? "big-img" : ""}`}
                  src={showEasyBot ? easyBotIcon : sologenieLogi}
                  alt="Chat Icon"
                />
              </div>
              {isChatOpen && <ChatBotPopUp open={isChatOpen} close={closeChatPopup} />}
            </div>
          </div>
          <Footer myTheme={myTheme} />
        </div>
      </div>
    </>
  );
};

export default Home;
